import { create } from 'zustand';

import { Report } from 'types/reporting/Report';

type ReportDataState = {
  reports: Report[];
  setReports: (reports: Report[]) => void;
  setReportFetching: (reportId: string, isFetching: boolean) => void;
  setReportData: (report: Report) => void;
  getReport: (reportId: string) => any;
};

export const useReportDataStore = create<ReportDataState>((set, get) => ({
  reports: [],

  setReports: (reports) => set({ reports }),
  setReportFetching: (reportId, isFetching) => {
    const reports = get().reports;

    const oldVersion = reports.find((report: Report) => report.id === reportId);

    if (!oldVersion) {
      return;
    }

    const updatedReport = {
      ...oldVersion,
      fetching: isFetching,
    };

    set((state) => ({
      reports: [
        ...state.reports.filter((report: Report) => report.id !== reportId),
        updatedReport,
      ],
    }));
  },
  setReportData: (newReport) => {
    set((state) => ({
      reports: [
        ...state.reports.filter((report: Report) => report.id !== newReport.id),
        newReport,
      ],
    }));
  },
  getReport: (reportId) => {
    return get().reports.find((d: Report) => d.id === reportId);
  },
}));
